<template>
  <div class="page-login">
    <form
      class="form-signin"
      @submit.prevent="login"
    >
      <div class="text-center mb-4">
        <h1 class="h3 mb-3 font-weight-normal">Вход</h1>
      </div>

      <div class="form-label-group">
        <label class="w-100">Пользователь
          <input
            name="LoginForm[username]"
            class="form-control"
            placeholder="Имя пользователя"
            required
            autofocus
          >
        </label>
      </div>

      <div class="form-label-group">
        <label class="w-100">Пароль
          <input
            type="password"
            name="LoginForm[password]"
            class="form-control"
            placeholder="Пароль"
            required
          >
        </label>
      </div>
      <div v-show="error" style="color:#a94442">{{ error }}</div>
      <div class="mb-3">
        <label>
          <input
            type="checkbox"
            name="LoginForm[rememberMe]"
            checked
          > Запомнить меня
        </label>
      </div>
      <button class="btn btn-lg btn-primary btn-block mb-3" type="submit">Вход</button>
      <router-link to="/password-reset" class="btn btn-link">Восстановление пароля</router-link>
    </form>
  </div>
</template>

<script>
export default {
  name: 'Login',
  data () {
    return {
      error: null
    }
  },
  methods: {
    login(event) {
      const formData = new URLSearchParams(new FormData(event.target))

      fetch('/back/site/login', {
        method: 'POST',
        body: formData
      })
      .then(response => {
        return response.json()
      })
      .then(result => {
        if (result.success) {
          window.location.href = '/'
        } else {
          this.error = result.message || 'Ошибка входа'
        }
      })
      .catch(() => {
        this.error = 'Ошибка входа'
      })
    },
  },
}
</script>

<style scoped>
  .page-login {
    max-width: 420px;
    width: 100%;
    position: fixed;
    left: 50%;
    top: 33%;
    transform: translate(-50%, -33%);
    padding: 10px;
  }

  label {
    padding: 10px 0px 0px 0px;
  }
</style>
